import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import {
  Button,
  Box,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
  FormControlLabel,
  Switch,
  Typography,
  IconButton,
  ListItemSecondaryAction
} from '@mui/material';
import  {
  PictureAsPdf,
  Image,
  Upload,
  InsertDriveFile,
  Delete
} from '@mui/icons-material';
import dayjs from 'dayjs';
import 'dayjs/locale/ko';
import { format } from 'date-fns'; 
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import Quill from 'quill';
import { Delta } from 'quill';  // Delta import 추가
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { FilePond } from 'react-filepond';

import { dateFormat } from '../../../utils';
import { Accordion, AccordionSummary, AccordionDetails } from "../../accordion";
import { FormInputText, FormInputSwitch, FormInputDate } from "../../form";
import { AlertDialog, DialogTitleClose, PaperComponent } from "../../dialog";
import { noticeModules, noticeFormats, noticeStyle, createNoticeModules, registerNotice } from '../../../utils/QuillConfig';
import { fields } from '../../../utils/validationSchemas';
import { gcoreServerUrl, mode, fileServerUrl, uploadFilePath } from '../../../config';
import uploadLabels from '../../../FildPondLabel';
import SecurityUtil from '../../../utils/SecurityUtils';

import * as gnoticeStore from "../../../store/gnotice";
import * as gfileStore from "../../../store/gfiles";

// 한국어 로케일 설정
dayjs.locale('ko');

const defaultValues = {
  title: "",
  startDate: "",
  endDate: "",
  popupYn: false,
  content: "",
};

const noticeSchema = yup.object({
  title: fields.title,
  startDate: fields.startDate,
  endDate: fields.endDate,
}).required();

let pond;

const NoticeFormDialog = ({ 
  crudMode ='C',
  open,
  setOpen,
  selectedRow,
  refresh,
 }) => {

  // 컴포넌트 마운트 시 폰트 등록
  useEffect(() => {
    // Quill 모듈 등록
    registerNotice();
  
  }, []);

  const quillRef = useRef(null);

  const [title, setTitle] = useState(selectedRow?.title || '');
  const [startDate, setStartDate] = useState(selectedRow?.startDate ? dayjs(selectedRow.startDate) : null);
  const [endDate, setEndDate] = useState(selectedRow?.endDate ? dayjs(selectedRow.endDate) : null);
  const [popupYn, setPopupYn] = useState(selectedRow?.popupYn || false);
  const [content, setContent] = useState(selectedRow?.content || '');
  const [attachments, setAttachments] = useState([]);
  const [uploadedImages, setUploadedImages] = useState([]);
  const [alertInfo, setAlertInfo] = useState({});
  const [files, setFiles] = useState([]);         // FilePond 관련 상태 추가


  const { handleSubmit, reset, control, setValue, getValues, formState: { errors } } = useForm({ 
    resolver: yupResolver(noticeSchema),
    defaultValues: defaultValues,
    mode: "onChange"  // 실시간 유효성 검사
  });


  // 첫 번째 useEffect - 초기 데이터 설정
  useEffect(() => {
    if (open) {
      // isEditorInitialized.current = false;
      // setEditorReady(false);
      initDialog();
      if (crudMode === 'U' && selectedRow) {
        initFormData(selectedRow);
        // setPendingContent(selectedRow.content);  // 컨텐츠를 대기 상태로 저장
      } else {
        initDates();
      }
    }
  }, [open]); 

  // 두 번째 useEffect - 에디터 content 설정
  // useEffect(() => {
  //   if (open && editorReady && pendingContent && !isEditorInitialized.current) {
  //     console.log("Initializing editor content");
  //     setIsInitializing(true);
  //     const editor = quillRef.current.getEditor();
      
  //     try {
  //       // 원본 HTML을 파싱
  //       const parser = new DOMParser();
  //       const originalDoc = parser.parseFromString(pendingContent, 'text/html');
        
  //       // 이미지 속성 보존을 위한 처리
  //       const originalImages = originalDoc.getElementsByTagName('img');
  //       const imageAttributes = new Map();
        
  //       Array.from(originalImages).forEach(img => {
  //         const src = img.getAttribute('src');
  //         imageAttributes.set(src, {
  //           width: img.getAttribute('width'),
  //           style: img.getAttribute('style')
  //         });
  //       });
  
  //       // 공백과 들여쓰기 보존을 위한 처리
  //       const originalParagraphs = originalDoc.getElementsByTagName('p');
  //       Array.from(originalParagraphs).forEach(p => {
  //         p.innerHTML = p.innerHTML.replace(/\s{2,}/g, match => 
  //           '&nbsp;'.repeat(match.length)
  //         );
  //       });
  
  //       // Delta 형식으로 변환
  //       const delta = editor.clipboard.convert(originalDoc.body.innerHTML);
        
  //       // 이미지 속성 복원
  //       delta.ops = delta.ops.map(op => {
  //         if (op.insert && op.insert.image) {
  //           const attributes = imageAttributes.get(op.insert.image);
  //           if (attributes) {
  //             return {
  //               insert: { image: op.insert.image },
  //               attributes: {
  //                 width: attributes.width,
  //                 style: attributes.style
  //               }
  //             };
  //           }
  //         }
  //         return op;
  //       });
  
  //       // Delta를 에디터에 적용
  //       editor.setContents(delta, 'api');
        
  //       // 추가적인 이미지 속성 보존
  //       const editorImages = editor.root.getElementsByTagName('img');
  //       Array.from(editorImages).forEach(img => {
  //         const attributes = imageAttributes.get(img.src);
  //         if (attributes) {
  //           if (attributes.width) {
  //             img.setAttribute('width', attributes.width);
  //             img.style.width = attributes.width + 'px';
  //           }
  //           if (attributes.style) {
  //             img.setAttribute('style', attributes.style);
  //             img.style.cssText = attributes.style;
  //           }
  //         }
  //       });
        
  //       isEditorInitialized.current = true;
  //       setContent(editor.root.innerHTML);
  //       setPendingContent(null);
  //       console.log("editor.root.innerHTML ===> ", editor.root.innerHTML);
  //       console.log("Editor content initialized successfully");
  //     } catch (error) {
  //       console.error("Error initializing editor content:", error);
  //     } finally {
  //       setTimeout(() => {
  //         setIsInitializing(false);
  //       }, 100);
  //     }
  //   }
  // }, [open, pendingContent, editorReady]);

  const initDialog = () => {
    setContent('');
    setTitle('');
    setStartDate(null);
    setEndDate(null);
    setPopupYn(false);
    setAttachments([]);  // 첨부파일 초기화
    setUploadedImages([]);  // 업로드된 이미지 초기화
    reset(defaultValues);  // form 초기화
    setFiles([]);
  }

  const handleDialogClose = () => {
    setOpen(false);
    initDialog();
  };

  // 날짜 초기화 함수 추가
  const initDates = () => {
    const today = dayjs();
    const endDate = today.add(7, 'day');
    
    setStartDate(today);
    setEndDate(endDate);
    setValue('startDate', today);
    setValue('endDate', endDate);
  };

  // 폼 데이터 초기화 함수
  const initFormData = (selectedRow) => {
    console.log("initFormData called with:", selectedRow);

    const sanitizedContent = SecurityUtil.sanitizeHtml(selectedRow?.content);

    // 기본 데이터 설정
    setTitle(selectedRow.title || '');
    setStartDate(selectedRow.startDate ? dayjs(selectedRow.startDate) : null);
    setEndDate(selectedRow.endDate ? dayjs(selectedRow.endDate) : null);
    setPopupYn(selectedRow.popupYn || false);
    
    setContent(sanitizedContent || '');
    //setPendingContent(selectedRow.content || '');

    // content에서 이미지 URL 추출하여 uploadedImages 설정
    if (sanitizedContent) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = sanitizedContent;
      const images = Array.from(tempDiv.getElementsByTagName('img')).map(img => img.getAttribute('src'));
      setUploadedImages(images);
      console.log("Extracted images from content:", images);
    }
    
    // form 값 설정
    if (selectedRow) {
      for (const [item, value] of Object.entries(defaultValues)) {
        setValue(item, selectedRow[item] || value);
      }
    }

    // 첨부파일 설정
    if (selectedRow.attachments && selectedRow.attachments.length > 0) {
      setAttachments(selectedRow.attachments);
      // FilePond 파일 설정
      const initialFiles = selectedRow.attachments.map(file => ({
        source: file.seq,
        options: {
          type: 'local',
          file: {
            name: file.filename,
            size: file.size,
            type: file.contentType
          },
          metadata: {
            seq: file.seq,
            refType: file.refType
          }
        }
      }));
      setFiles(initialFiles);
    }
  };

  // 에디터 내용 변경 핸들러
  const handleEditorChange = useCallback((content, delta, source, editor) => {
    //console.log("handleEditorChange called with:", { content, delta, source, editor });
    
    try {
      // content가 HTML 문자열인 경우
      if (typeof content === 'string') {
        // content 상태 업데이트
        setContent(content);
  
        // 이미지 처리
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = content;
        const currentImages = Array.from(tempDiv.getElementsByTagName('img')).map(img => ({
          src: img.getAttribute('src'),
          width: img.getAttribute('width'),
          style: img.getAttribute('style')
        }));
  
        //console.log("Current images:", currentImages);
  
        // 삭제된 이미지 확인
        const deletedImages = uploadedImages.filter(original => 
          !currentImages.some(current => current.src === original)
        );
  
        // 삭제된 이미지가 있으면 서버에서 삭제
        if (deletedImages.length > 0) {
          console.log("Deleting images:", deletedImages);
          deletedImages.forEach(async (imageUrl) => {
            try {
              const urlObj = new URL(imageUrl);
              const pathParts = urlObj.pathname.split('/');
              const seq = pathParts[pathParts.indexOf('seq') + 1];
              const refType = pathParts[pathParts.indexOf('refType') + 1];
  
              console.log({seq, refType, imageUrl});
  
              await gfileStore.removeFile({ seq: seq, refType: refType });
             
              setUploadedImages(prev => 
                prev.filter(url => url !== imageUrl)
              );
            } catch (error) {
              console.error('이미지 삭제 실패:', error);
            }
          });
        }
      }
    } catch (error) {
      console.error("Error updating editor content:", error);
    }
  }, [uploadedImages]);

  // const handleEditorChange___ = useCallback((content, delta, source, editor) => {
  //   console.log("handleEditorChange called with:", { content, delta, source, editor });
    
  //   // 초기화 중인 경우 스킵
  //   if (isInitializing) {
  //     console.log("Skipping content update during initialization");
  //     return;
  //   }
  
  //   // editor가 유효한지 확인
  //   if (!editor || !editor.root) {
  //     console.log("Editor is not ready yet");
  //     return;
  //   }
  
  //   try {
  //     // Delta 구조 로깅
  //     console.log("Delta structure:", {
  //       ops: delta.ops,
  //       length: delta.length(),
  //       attributes: delta.ops.map(op => op.attributes)
  //     });
  
  //     // 현재 에디터의 내용을 가져옴
  //     const currentContent = editor.root.innerHTML;
  //     console.log("Current editor content:", currentContent);
  
  //     // 이미지 속성 보존을 위한 임시 div 사용
  //     const tempDiv = document.createElement('div');
  //     tempDiv.innerHTML = currentContent;
  
  //     // 현재 이미지 URL 추출
  //     const currentImages = Array.from(tempDiv.getElementsByTagName('img')).map(img => ({
  //       src: img.getAttribute('src'),
  //       width: img.getAttribute('width'),
  //       style: img.getAttribute('style')
  //     }));
  
  //     console.log("Current images:", currentImages);
  
  //     // 삭제된 이미지 확인
  //     const deletedImages = uploadedImages.filter(original => 
  //       !currentImages.some(current => current.src === original)
  //     );
  
  //     // 삭제된 이미지가 있으면 서버에서 삭제
  //     if (deletedImages.length > 0) {
  //       console.log("Deleting images:", deletedImages);
  //       deletedImages.forEach(async (imageUrl) => {
  //         try {
  //           const urlObj = new URL(imageUrl);
  //           const pathParts = urlObj.pathname.split('/');
  //           const seq = pathParts[pathParts.indexOf('seq') + 1];
  //           const refType = pathParts[pathParts.indexOf('refType') + 1];
  
  //           console.log({seq, refType, imageUrl});
  
  //           await gfileStore.removeFile({ seq: seq, refType: refType });
           
  //           setUploadedImages(prev => 
  //             prev.filter(url => url !== imageUrl)
  //           );
  //         } catch (error) {
  //           console.error('이미지 삭제 실패:', error);
  //         }
  //       });
  //     }
  
  //     // 이미지 속성이 있는 경우 보존
  //     currentImages.forEach(img => {
  //       if (img.width || img.style) {
  //         const imgElement = tempDiv.querySelector(`img[src="${img.src}"]`);
  //         if (imgElement) {
  //           if (img.width) imgElement.setAttribute('width', img.width);
  //           if (img.style) imgElement.setAttribute('style', img.style);
  //         }
  //       }
  //     });
  
  //     // 최종 내용 업데이트
  //     const finalContent = tempDiv.innerHTML;
  //     console.log("Final content to be set:", finalContent);
      
  //     // 에디터 내용 직접 업데이트
  //     if (editor && editor.root) {
  //       editor.root.innerHTML = finalContent;
  //       // 상태 업데이트
  //       setContent(finalContent);
  //     }
  
  //   } catch (error) {
  //     console.error("Error updating editor content:", error);
  //   }
  // }, [isInitializing, uploadedImages]);
  

  // 저장 버튼 클릭 시 실행
  const onSubmit = async (data) => {
    //console.log(data);

    if (!content?.trim()) {
      setAlertInfo({
        titleAlert: "입력 오류",
        messageAlert: "내용을 입력해주세요.",
        open: true,
      });
      return;
    }

    const formattedStartDate = dayjs(data.startDate).startOf('day').format('YYYY-MM-DD HH:mm:ss');
    const formattedEndDate = dayjs(data.endDate).endOf('day').format('YYYY-MM-DD HH:mm:ss');
    try {
      // 첨부파일 정보 가공
      const formattedAttachments = attachments.map(file => ({
        seq: file.seq,
        refType: file.refType || 'NOTI'  // refType이 없는 경우 기본값 설정
      }));
      
      const noticeData = {
        title: data.title,
        content: content,
        startDate: formattedStartDate,
        endDate: formattedEndDate,
        popupYn: popupYn,
        attachments: formattedAttachments,
      };

      console.log("전송할 공지사항 데이터:", {
        crudMode,
        id: crudMode === 'U' ? selectedRow.id : undefined,
        ...noticeData
      });

      let response = null;

      if (crudMode === 'C') {
        response = await gnoticeStore.create(noticeData);
      } else {
        response = await gnoticeStore.modify(selectedRow.id, noticeData);
      }
  
      console.log("response:", response.gnotice);

      handleDialogClose();
      // 성공 메시지 표시
      alert("공지사항이 저장되었습니다.");
      refresh();
      
    } catch (error) {
      console.error('공지사항 저장 실패:', error);
      const message = error.serverResponse?.message || '공지사항 저장에 실패했습니다.';
      setAlertInfo({
        open: true,
        titleAlert: '저장 오류',
        messageAlert: message
      });
    }
  };

  // 이미지 업로드 핸들러
  const imageHandler = useMemo(() => {
    return async () => {
      const input = document.createElement('input');
      input.setAttribute('type', 'file');
      input.setAttribute('accept', 'image/*');
      
      return new Promise((resolve, reject) => {
        input.onchange = async () => {
          const file = input.files[0];
          if (file) {
            try {
              const formData = new FormData();
              formData.append('filepond', file);
              formData.append('refType', 'HTML');  // HTML 수정

              const response = await gfileStore.sendFile(formData);

              console.log("response ===> ", response);
              
              if (!response.gfile) {
                throw new Error('이미지 업로드 실패');
              }

              // 이미지 URL 추출
              const imageUrl = await gfileStore.getFileUrl(response.gfile.seq, response.gfile.refType);

              console.log("imageUrl ===> ", imageUrl);
              
              // 업로드된 이미지 정보 저장
              setUploadedImages(prev => [...prev, imageUrl]);
              
              const editor = quillRef.current.getEditor();
              const range = editor.getSelection();
              editor.insertEmbed(range.index, 'image', imageUrl);

              // 이미지 URL을 직접 반환
              return imageUrl;
              //resolve(imageUrl);
            } catch (error) {
              console.error('이미지 업로드 실패:', error);
              setAlertInfo({
                open: true,
                titleAlert: '업로드 오류',
                messageAlert: '이미지 업로드에 실패했습니다.'
              });
              reject(error);
            }
          }
        };
        
        input.click();
      });
    };
  }, []);

  // 삭제 버튼 핸들러
  const handleClickDelete = async () => {
    setAlertInfo({
      titleAlert: "안내",
      messageAlert: "공지사항을 삭제하시겠습니까?",
      type: 'confirm',
      open: true,
      confirmText: "예",
      cancelText: "아니오",
      handleConfirm: async () => {

        try {
          // 첨부파일 삭제
          if (attachments.length > 0) {
            attachments.forEach(async (file) => {
              await gfileStore.removeFile({ seq: file.seq, refType: file.refType });
            });
          }

          await gnoticeStore.remove(selectedRow.id);
        } catch (error) {
          console.error('공지사항 삭제 실패:', error);
        }

        refresh();
        handleDialogClose();
      }
    });
  };


  // noticeModules 생성
  const noticeModules = useMemo(() => 
    createNoticeModules(imageHandler), 
    [imageHandler]
  ); 

  // FilePond 설정
  const pondOptions = {
    ...uploadLabels,  // FilePondLabel 적용
    allowMultiple: true,
    allowRevert: true,
    instantUpload: true,
    allowRemove: true,
    maxFiles: 5,
    server: {
      url: gcoreServerUrl,
      process: {
        url: '/api/gfiles',
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('accessToken')}`,
        },
        method: 'POST',
        timeout: 7000,
        ondata: (formData) => {
          formData.append('refType', 'NOTI');
          if (crudMode === 'U') {
            formData.append('refId', selectedRow.id);
          }
          return formData;
        },
        onload: (response) => {
          const data = JSON.parse(response);
          console.log("data ===> ", data);
          setAttachments(prev => [...prev, data.gfile]);
          if (crudMode === 'U') {
            refresh();
          }
          return data.gfile;
        },
        onerror: (response) => {
          console.error('파일 업로드 실패:', response);
          return response;
        }
      },
      revert: (gfile, load, error) => {
        console.log("revert gfile ===> ", gfile);
  
        // uniqueFileId가 객체이고 gfile 속성이 있는지 확인
        if (!gfile) {
          console.log('파일 정보를 찾을 수 없습니다.');
          return;
        }

        const { seq, refType } = gfile;
        
        if (!seq || !refType) {
          console.log('파일 정보가 올바르지 않습니다.');
          return;
        }

        // DELETE 요청 수행
        gfileStore.removeFile({ seq: seq, refType: refType })
        .then(response => response.json())
        .then(data => {
          setAttachments(prev => prev.filter(file => file.seq !== seq));
          load(); // 성공 시 load() 호출
        })
        .catch(err => {
          console.log(err); // 실패 시 error() 호출
        });
      }
    }
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleDialogClose}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        //maxWidth="sm"
        sx={{
          '& .MuiDialog-paper': {
            maxWidth: '630px',
            maxHeight: '100vh'  // 화면 높이의 90%로 제한
          }
        }}
      >
        <DialogTitleClose
          id="draggable-dialog-title"
          onClose={handleDialogClose}
          style={{ cursor: 'move' }}
        >
          {`공지사항 ${crudMode === 'U' ? '수정' : '등록'}`}
        </DialogTitleClose>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormInputText
                name="title"
                control={control}
                label={"제목"}
                required
                errorStyle={{border: true }}
                error={!!errors.title}
                helperText={errors.title?.message}
              />
            </Grid>
          
            <Grid item xs={6}>
              <FormInputDate
                name={"startDate"}
                control={control}
                label={"공지 시작일"}
                value={getValues("startDate")}
                setValue={setValue}
                getValues={getValues}
                inputHeight={38}
                required
                errorStyle={{border: true }}
              />
            </Grid>
            <Grid item xs={6}>
              <FormInputDate
                name={"endDate"}
                control={control}
                label={"공지 종료일"}
                value={getValues("endDate")}
                setValue={setValue}
                getValues={getValues}
                inputHeight={38}
                required
                errorStyle={{border: true }}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Switch
                    checked={popupYn}
                    onChange={(e) => setPopupYn(e.target.checked)}
                  />
                }
                label="공지 팝업여부"
              />
            </Grid>
            <Grid item xs={12}>
              <Box 
                sx={{  mb: 0,
                '& .filepond--root': {
                  width: '100%',
                  height: 'auto',
                  margin: 0,
                },
                '& .filepond--panel-root': {
                  backgroundColor: 'transparent',
                  border: '1px dashed',
                  borderColor: 'divider',
                },
                '& .filepond--drop-label': {
                  color: 'text.secondary',
                  height: '50px !important',
                },
                '& .filepond--label-action': {
                  color: 'primary.main',
                  textDecoration: 'underline',
                },
                // 로컬 파일일 경우 X 버튼 위치 변경
                '& .filepond--action-remove-item': {
                  right: '0.5em !important',
                  left: 'auto !important',
                  transform: 'none !important'
                },
                '& .filepond--action-remove-item[data-align="left"]': {
                  right: '0.5em !important',
                  left: 'auto !important',
                  transform: 'none !important'
                },
                // 로컬 파일일 경우 파일명 위치 조정
                '& .filepond--file-info': {
                  transform: 'none !important',
                  marginLeft: '0.5em !important',
                  marginRight: '2.5em !important',
                  position: 'relative !important',
                  left: '0 !important'
                },
                '& .filepond--file-info-main': {
                  marginLeft: '0.5em !important'
                },
                // 아이템 패딩 추가
                '& .filepond--item': {
                  marginBottom: '2px !important'
                },
                // Powered by PQINA 제거
                '& .filepond--credits': {
                  display: 'none !important'
                }
              }}>
                  <FilePond
                    ref={ref => pond = ref}
                    files={files}
                    onupdatefiles={setFiles}
                    onremovefile={async (error, file) => {
                      // 파일 메타데이터 가져오기
                      const metadata = file.getMetadata();
                      console.log("metadata ===> ", metadata);
                      // 로컬 파일만 처리
                      if (metadata && metadata.seq && metadata.refType) {

                        try {
                          console.log("Delete File metadata ===> ", metadata);
                          const response = await gfileStore.removeFile({ seq: metadata.seq, refType: metadata.refType });
                          
                          if (!response) {
                            throw new Error('파일 삭제 실패');
                          }
                          
                          setAttachments(prev => prev.filter(f => f.seq !== metadata.seq));

                          if (crudMode === 'U') {
                            refresh();
                          }
                        } catch (err) {
                          console.error('파일 삭제 실패:', err);
                        }
                      }
                    }}
                    {...pondOptions}
                    stylePanelLayout="compact"
                    styleLoadIndicatorPosition="center"
                    styleProgressIndicatorPosition="right"
                    styleButtonRemoveItemPosition="left"
                    styleButtonProcessItemPosition="right"
                  />
                  
              </Box>
            </Grid>
            <Grid item xs={12}>
              {/* <Typography variant="subtitle2" 
                  sx={{ 
                    mb: 1,
                    color: 'text.secondary',
                    fontSize: '0.875rem',
                    '& strong': {
                      color: 'primary.main',
                      fontWeight: 600,
                      fontSize: '1rem'
                    }
                  }}
                >
                  ※ 에디터에 삽입하는 이미지 크기는 <strong>520px</strong>로 리사이징 해 주세요.
              </Typography> */}
              <Box sx={noticeStyle}>
                {/* <Typography 
                  variant="subtitle1" 
                  sx={{ 
                    marginBottom: 1,
                    fontWeight: 500,
                    color: 'rgba(0, 0, 0, 0.87)'
                  }}
                >
                  {"공지사항 내용"}
                </Typography> */}
                <ReactQuill
                  ref={quillRef}
                  value={content}
                  onChange={handleEditorChange}
                  modules={noticeModules}
                  formats={noticeFormats}
                  placeholder="공지사항 내용을 입력하세요..."
                  theme="snow"
                  style={{ 
                    width: '100%',
                    height: 'auto',
                    marginBottom: '0px',
                    position: 'relative',
                    zIndex: 1
                  }}
                  preserveWhitespace={true}  // 공백 보존
                  preserveBlank={true}  // 공백 보존
                  // onFocus={() => {
                  //   if (!isInitializing && editor && editor.root) {
                  //     const images = editor.root.getElementsByTagName('img');
                  //     Array.from(images).forEach(img => {
                  //       const width = img.getAttribute('width');
                  //       const style = img.getAttribute('style');
                  //       if (width) {
                  //         img.style.width = width + 'px';
                  //       }
                  //       if (style) {
                  //         img.style.cssText = style;
                  //       }
                  //     });
                  //   }
                  // }}
                  // onFocus={() => {
                  //   // 에디터 포커스 시 이미지 클릭 이벤트 처리
                  //   const editor = quillRef.current.getEditor();
                  //   const editorElement = editor.root;
                    
                  //   editorElement.addEventListener('click', (e) => {
                  //     // 이미지 클릭 이벤트 방지
                  //     if (e.target.tagName === 'IMG') {
                  //       e.preventDefault();
                  //       e.stopPropagation();
                  //     }
                  //   }, true);
                  // }}
                />
                
              </Box>
            </Grid> 
          </Grid>
        </DialogContent>
        <DialogActions>
          {crudMode === 'U' && (
            <>
              <Button onClick={handleClickDelete} sx={{ ml: '15px' }}>삭제</Button>
              <Box sx={{ flex: 1 }} /> {/* 스페이서 */}
            </>
          )}
          <Button onClick={handleSubmit(onSubmit)}>{"저장"}</Button>
          <Button onClick={handleDialogClose}>{"닫기"}</Button>
        </DialogActions>
      </Dialog>
      <AlertDialog
        alertInfo={alertInfo}
        setAlertInfo={setAlertInfo}
      />
    </>
  );
};

export default NoticeFormDialog;